import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { AiFillStar } from "react-icons/ai";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

function Feedback() {
  const [rating, setRating] = useState(0);

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const getRatingLabel = (r) => {
    const labels = {
      0: "",
      1: "(Poor)",
      2: "(Fair)",
      3: "(Good)",
      4: "(Very Good)",
      5: "(Excellent)"
    };
    return labels[r];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const user_captcha = e.target.captcha.value;

    if (rating === 0) {
      alert("Please select a rating.");
      return;
    }

    if (validateCaptcha(user_captcha) === true) {
      e.target.action = "https://formsubmit.co/vbumca@gmail.com";
      e.target.method = "POST";
      e.target.submit();
    } else {
      alert("Captcha does not match. Please try again.");
      loadCaptchaEnginge(6);
      e.target.captcha.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>Feedback - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Student Feedback</h1>
        </div>
        <div className="FeedbackSection" data-aos="fade-up">
          <div className="FeedbackContent">
            <p className="FeedbackDesc">
              We value your feedback! Please let us know how we can improve our department and services for you.
            </p>
            <form className="StandardForm FeedbackForm" onSubmit={handleSubmit}>
              <input type="hidden" name="_subject" value="New Student Feedback - VBU MCA" />
              <input type="hidden" name="rating" value={`${rating} ${getRatingLabel(rating)}`} />
              <div className="FormRow">
                <div className="InputField">
                  <label>Full Name</label>
                  <input type="text" name="name" placeholder="Your Name" required />
                </div>
                <div className="InputField">
                  <label>Email Address</label>
                  <input type="email" name="email" placeholder="Your Email" required />
                </div>
              </div>
              
              <div className="InputField">
                <label>Rating</label>
                 <div className="RatingStars" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                   {[1, 2, 3, 4, 5].map((star) => (
                     <AiFillStar 
                       key={star} 
                       className="StarDetail" 
                       size={30} 
                       color={star <= rating ? "#ffc107" : "#e4e5e9"} 
                       onClick={() => setRating(star)}
                     />
                   ))}
                   <span className="RatingLabel" style={{ marginLeft: '15px', color: '#ffb300', fontWeight: '600' }}>
                     {getRatingLabel(rating)}
                   </span>
                 </div>
              </div>

              <div className="InputField">
                <label>Your Message</label>
                <textarea name="message" placeholder="Tell us what you think..." rows="5" required></textarea>
              </div>
              
              <div className="InputField">
                <label>Enter Captcha</label>
                <div className="CaptchaWrapper" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <LoadCanvasTemplate />
                  <input
                    type="text"
                    name="captcha"
                    placeholder="Enter Captcha Here"
                    className="capthca_box"
                    required
                    style={{ width: '200px' }}
                  />
                </div>
              </div>
              
              <button type="submit" className="SubmitBtn">Send Feedback</button>
            </form>
          </div>
          <div className="FeedbackIllustration">
             <div className="GlassCard">
                <h4>Why your feedback matters?</h4>
                <p>Your insights help us enhance the academic environment and student experience at VBU MCA.</p>
                <div className="PulseCircle"></div>
             </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Feedback;
